<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row">
              <b-form-group
                description="Search Keyword"
                class="me-3 custom-search-width"
              >
                <form class="d-flex">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="custom-search-icon">
                        <i class="bx bx-search-alt-2"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      class="rounded-0 custom-input"
                      v-model="search.keyword"
                      type="search"
                      placeholder="Search here..."
                      @keydown.enter.prevent="isSearching = true; getCollaterals()"
                    ></b-form-input>
                  </b-input-group>
                </form>
              </b-form-group>

              <b-form-group
                description="Filter by Status"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-form-select
                    v-model="search.status"
                    class="form-select shadow-none"
                    :options="statusFilter"
                    @change="isSearching = true; getCollaterals()"
                  >
                  </b-form-select>
                </form>
              </b-form-group>

              <b-form-group
                description="Filter by Shipping Status"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-form-select
                    v-model="search.shippingStatus"
                    class="form-select shadow-none"
                    :options="shippingStatusFilter"
                    @change="isSearching = true; getCollaterals()"
                  >
                  </b-form-select>
                </form>
              </b-form-group>

              <b-form-group
                description="Filter by Collaterals"
                class="me-3 custom-fg-width"
              >
                <form class="d-flex">
                  <b-form-select
                    v-model="search.collateralType"
                    class="form-select shadow-none"
                    :options="collateralsFilter"
                    @change="isSearching = true; getCollaterals()"
                  >
                  </b-form-select>
                </form>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <b-row class="mb-2 d-flex flex-row align-items-center">
              <b-col sm class="mt-2 mb-2">
                <div class="align-items-center">
                  <span class="fw-bold">
                    <label class="fs-5">Collateral List</label>
                    <b-badge pill class="cstm-badge fs-6">{{
                      this.collateralsTotalRows
                    }}</b-badge>
                  </span>
                </div>
              </b-col>
              <b-col sm class="mt-2 mb-2">
                <div
                  class="d-flex flex-wrap align-items-center justify-content-md-end mt-md-0 gap-2"
                >
                  <b-button 
                    size="sm" 
                    variant="primary" 
                    class="ps-3 pe-3 pt-0 pb-0 d-flex flex-row align-items-center"
                    @click="onExport">
                      <div class="mdi mdi-upload-outline" style="font-size: 24px"></div> 
                      <div class="">Export</div>
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="collaterals"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :per-page="perPage"
                  class="table-check"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :busy="isLoading"
                >
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle me-2"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>

                  <template #cell(collaterals)="data">
                    <div class="text-capitalize">{{ data.item.type }}</div>
                  </template>

                  <template #cell(store_name)="data">
                    <div>{{ data.item.store_name }}</div>
                  </template>

                  <template #cell(status)="data">
                    <div>{{ data.item.mobile_status }}</div>
                  </template>

                  <template #cell(shipping_status)="data">
                    <div>{{ data.item.web_status }}</div>
                  </template>

                  <!-- <template #cell(size)="data">
                    <div>{{ data.item.dimension }}</div>
                  </template> -->
                </b-table>
              </div>
            </div>
            <div class="row g-0 text-center" v-if="collateralsTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <!-- end table responsive -->

            <!-- </div> -->
            <div class="row g-0 text-center text-sm-start" v-if="collateralsTotalRows > 10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <label class="col-form-label d-inline-block me-4"
                      >Display:</label
                    >
                    <div class="d-inline-block">
                      <b-form-group label-for="display-record">
                        <b-form-select
                          size="sm"
                          class="form-select shadow-none w-fit"
                          id="display-record"
                          v-model="perPage"
                          :options="pageOptions"
                          @change="currentPage = 1; getCollaterals()"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                    <!-- <div class="form-group row pull-left">
                          </div> -->
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                      v-if="collateralsTotalRows > perPage"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        :total-rows="collateralsTotalRows"
                        :per-page="perPage"
                        limit="1"
                        first-number
                        last-number
                        @input="getCollaterals"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->
            </div>

            <b-row class="mt-2">
              <div style="width: fit-content">
                <a
                  href="javascript:void(0);"
                  class="d-flex flex-row align-items-center"
                  @click="$router.back()"
                >
                  <div
                    class="mdi mdi-chevron-left me-2"
                    style="font-size: 24px"
                  ></div>
                  <div class="text-dark">
                    Back to Marketing Campaigned Details
                  </div>
                </a>
              </div>
            </b-row>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <toast
      :type="toastType"
      v-if="showToast"
      @close="() => (showToast = false)"
      :title="toastTitle"
      :message="toastMessage"
    />
  </div>
</template>

<script>
// import Swal from "sweetalert2";
import appConfig from "@/app.config";
import {
  layoutMethods,
  layoutComputed,
  campaignMethods,
  campaignComputed,
} from "@/state/helpers";
import Toast from "@/components/widgets/toast.vue";

/**
 * Users list component
 */
export default {
  page: {
    title: "Collateral List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      // title: "User",
      collaterals: [],
      collateralsTotalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "c.id",
      sortDesc: false,
      search: {
        keyword: "",
        status: null,
        shippingStatus: null,
        collateralType: null
      },
      fields: [
        {
          key: "collaterals",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "store_name",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "status",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "shipping_status",
          sortable: true,
          tdClass: "align-middle",
        },
        {
          key: "size",
          sortable: true,
          tdClass: "align-middle",
        },
        // {
        //   key: "qty_needed",
        //   sortable: false,
        //   tdClass: "align-middle",
        // },
      ],
      submitted: false,
      statusFilter: [
        { text: 'All', value: null },
        { text: 'To Ship', value: 'toShip' },
        { text: 'Shipping', value: 'shipping' },
        { text: 'Received', value: 'received' },
        { text: 'Checkpoint', value: 'checkpoint' },
      ],
      shippingStatusFilter: [
        { text: 'All', value: null },
        { text: 'To Ship', value: 'toShip' },
        { text: 'Shipping', value: 'shipping' },
        { text: 'Received', value: 'received' },
      ],
      collateralsFilter: [
        { text: 'All', value: null },
        { text: 'Tarpaulin', value: 'tarpaulin' },
        { text: 'Banner', value: 'banner' },
        { text: 'Window Box', value: 'window box' },
        { text: 'Hanger', value: 'hanger' },
      ],
      isLoading: false,
      isSearching: false,
    };
  },
  components: {
    Toast,
  },
  computed: {
    ...layoutComputed,
    ...campaignComputed,
  },
  async mounted() {
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "My Space", to: {} },
        { text: "Marketing Campaign Details", to: {} },
        { text: "Collateral List", to: {} },
      ],
    });
    this.changeBackButton({
      value: true,
    });
    this.changePrevRoute({
      name: `campaign-details/${this.$route.params.id}`,
      params: {},
    });
    
    this.getCollaterals();

    // get the module access for checking if user has create, read, update, and/or delete access
    // await getModuleAccess("Settings", "User Management", "Roles").then(
    //   (access) => (this.rolesModule.access = access)
    // );
  },
  methods: {
    ...layoutMethods,
    ...campaignMethods,
    getCollaterals() {
      this.isLoading = true;
      this.currentPage = this.isSearching ? 1 : this.currentPage;
      let params = {
        id: this.$route.params.id,
        page: this.currentPage,
        rows: this.perPage,
        search: this.search,
        sort: this.sortBy,
        sortDesc: this.sortDesc,
      };

      this.getCollateralList(params).then(() => {
        this.isLoading = false;
        this.isSearching = false;
        this.collaterals = this.collateralsList;
        this.collateralsTotalRows = this.collateralsTotal;
      });
    },
    onExport() {
      this.$toast.showToast('info', 'Coming Soon!', 'Stay tuned for this feature.');
    }
  },
};
</script>

<style scoped>
.cstm-badge {
  color: #fff;
  background-color: #0062ff;
  border-radius: 10px;
  margin-left: 10px;
}

.table {
  --bs-table-bg: transparent;
}

.table th {
  background-color: #f5f6f8;
}

.custom-search-icon {
  font-size: 1.5rem;
  background-color: transparent;
  border-right: 0px;
  border-radius: 5px 0px 0px 5px;
}

.custom-input {
  border-left: 0;
  border-radius: 0px 5px 5px 0px !important;
}

.table td {
  width: 400px;
}

.form-check-input {
  border-color: #7e93a059;
}

.custom-search-width {
  width: 400px;
}

.custom-fg-width {
  width: 300px;
}
</style>
